// extracted by mini-css-extract-plugin
export default {"selected":"f209fd23af","un":"_10232eb7ac"};